var textStyleControllerInit = function () {

    var inputControllers = $('[data-text-style-to-control] input');

    inputControllers.each(function (index) {
        $(this).attr('data-index', index);
    });

    inputControllers.on('change', function () {
        var parent = $(this).closest('[data-text-style-to-control]'),
        dataIdOfAssociatedContainer = parent.attr('data-text-style-to-control'),
        toBeStyleControlledContainer = $('[data-id=' + dataIdOfAssociatedContainer + ']'),
        colorClass = $(this).attr('data-color');

        if ($(this).is(':checked')) {
            //removes existing color class
            toBeStyleControlledContainer.
            removeClass(function (index, css) {
                return (css.match(/(^|\s)color-\S+/g) || []).join(' ');
            });

            //Now adds class for color to be changed 
            toBeStyleControlledContainer.addClass(colorClass);

            var spriteImgContainer = toBeStyleControlledContainer.find('.m-icon-nav-img'),

            containerHeight = spriteImgContainer.height(),

            img = toBeStyleControlledContainer.find('.m-icon-nav-img img')

            inputIndex = parseInt($(this).attr('data-index')) + 1,

            spriteImgPositioning = -containerHeight * inputIndex,

            positioningTime = 5;

            //Sets sprite image positioning according to checking of radio button 
            img.animate({ top: spriteImgPositioning }, positioningTime);
        }
    });
};